import React from 'react';

import type { ErrorInterface } from '@aline/common';
import { ErrorCodes, ErrorCodeSchema } from '@aline/common';
import type { GraphQLFormattedError } from 'graphql';
import { ErrorSnackbar } from 'src/components';
import { pushNotification } from 'src/notifications';
import { Sentry } from 'src/sentry';
import { v4 as uuid4 } from 'uuid';

export function handleError(
  error: ErrorInterface | GraphQLFormattedError,
  options: { message?: string; notify?: boolean } = {}
): void {
  Sentry.captureException(error);
  console.error(error);
  if (options.notify === false) return;
  if (options.message) {
    pushNotification({ key: uuid4(), message: options.message, variant: 'error' });
    return;
  }
  defaultErrorHandler();
}

/**
 * Utility function for getting an error code off an ApolloError or ErrorInterface if the code
 * exists.
 */
export function getErrorCode(error: ErrorInterface | GraphQLFormattedError): ErrorCodes | void {
  if ('response' in error) {
    const [
      {
        extensions: { code },
      },
    ] = error.response.errors;

    return code;
  }

  if ('extensions' in error) {
    const parseResult = ErrorCodeSchema.safeParse(error.extensions?.code);
    if (parseResult.success) return parseResult.data;
  }

  return ErrorCodes.INTERNAL;
}

function defaultErrorHandler(): void {
  const id = uuid4();
  pushNotification({ content: <ErrorSnackbar id={id} />, key: id, message: '', variant: 'error' });
}
